module.exports = __webpack_public_path__ + "static/media/landing-1-shape.5cdce748.svg";